import { alpha } from '@mui/material/styles';
import palette from './palette';

const LIGHT_MODE = palette.grey[500];

const createShadow = (color: string): [
  'none',
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string
] => {
  const transparent = alpha(color, 0.16);
  return [
    'none',
    `0px 1px 2px ${transparent}`,
    `0px 1px 4px ${transparent}`,
    `0px 1px 8px ${transparent}`,
    `0px 1px 12px ${transparent}`,
    `0px 2px 8px ${transparent}`,
    `0px 2px 12px ${transparent}`,
    `0px 4px 16px ${transparent}`,
    `0px 4px 20px ${transparent}`,
    `0px 4px 24px ${transparent}`,
    `0px 4px 28px ${transparent}`,
    `0px 4px 32px ${transparent}`,
    `0px 6px 36px ${transparent}`,
    `0px 6px 40px ${transparent}`,
    `0px 8px 44px ${transparent}`,
    `0px 8px 48px ${transparent}`,
    `0px 10px 52px ${transparent}`,
    `0px 10px 56px ${transparent}`,
    `0px 12px 60px ${transparent}`,
    `0px 12px 64px ${transparent}`,
    `0px 14px 68px ${transparent}`,
    `0px 14px 72px ${transparent}`,
    `0px 16px 76px ${transparent}`,
    `0px 16px 80px ${transparent}`,
    `0px 18px 84px ${transparent}`,
  ];
};

const shadows = createShadow(LIGHT_MODE);

export default shadows; 